export const ASSISTANT_GLOSSARY = [
  {
    key: 'assistant.agent',
    label: 'Agente',
    whatIs: 'Especialista que responde a pergunta. Automático deixa o roteador escolher; Genérico usa todas as ferramentas de uso; os de Uso do produto (PI) leem os números do PI e os de Áreas do produto contam o estoque de cada módulo.',
    purpose: 'Escolher o especialista certo dá respostas mais precisas e mais baratas. Na dúvida, deixe em Automático: o pé de cada resposta diz quem respondeu e como foi escolhido.',
    howGenerated: 'A lista vem do servidor do PI. No Automático, uma regra por palavras da pergunta escolhe o agente; se ela não decidir, um modelo roteador escolhe; sem especialista claro, a pergunta vai para o Genérico.',
    caveat: 'Receita e oportunidades só aparece para quem tem o acesso de Receita.',
    seeAlso: ['assistant.areaAgents'],
  },
  {
    key: 'assistant.areaAgents',
    label: 'Áreas do produto',
    whatIs: 'Especialistas por área (Ponto e Jornada, Desenvolvimento de Pessoas, Comunicação, Endomarketing, DP e Documentos, Recrutamento) que contam o que existe agora: PDIs em andamento, ajustes pendentes, vagas abertas e outros.',
    purpose: 'Respondem perguntas de estoque ("quantos existem", "pendentes", "atrasados"), que os números de uso do PI não respondem. A resposta diz o que é estoque e o que é uso.',
    howGenerated: 'Leem o retrato noturno de cada área, contado por empresa nos bancos dos clientes às 23:30 de Brasília, só com empresas ativas, sem as de demonstração e sem dado de pessoa.',
    caveat: 'O estoque é o da última madrugada: o que mudou hoje só aparece amanhã.',
  },
  {
    key: 'assistant.answerStatus',
    label: 'Status da resposta',
    whatIs: 'Resultado da pergunta: Respondida, Sem dado no PI, Fora do escopo, Precisa de esclarecimento, Limite da pergunta atingido ou Erro. Na conversa, o selo só aparece quando não é Respondida.',
    purpose: 'Separa resposta com número de recusa ou falha. Sem dado e Fora do escopo não são erro; Precisa de esclarecimento pede que você escolha uma das opções sugeridas.',
    howGenerated: 'Definido pelo servidor ao fim da pergunta: o modelo declara o status da resposta; Limite vem do teto de chamadas, consultas, tokens ou tempo (90 s) por pergunta; Erro vem de falha ou cancelamento na chamada ao modelo.',
  },
  {
    key: 'assistant.answerUsage',
    label: 'Consumo da resposta',
    whatIs: 'Linha no pé de cada resposta: quem respondeu, chamadas ao modelo, consultas ao PI, tokens de entrada (e quantos em cache), tokens de saída, custo em dólar e em reais e o tempo total.',
    purpose: 'Mostra quanto a pergunta custou e demorou, para comparar agentes e perguntas. O mesmo número entra no Consumo da IA.',
    howGenerated: 'Somado pelo servidor sobre todas as chamadas ao modelo da pergunta, inclusive a do roteador. Custo = tokens × preço por milhão da tabela do servidor; reais pelo câmbio configurado. Tempo do envio ao fim da resposta.',
    seeAlso: ['assistant.usage.cost', 'assistant.usage.inputTokens'],
  },
  {
    key: 'assistant.costEstimate',
    label: 'Estimativa de custo',
    whatIs: 'Quanto custa uma pergunta típica e os limites de uso: perguntas por pessoa a cada 10 minutos e por dia, e o teto de custo diário somado de todas as pessoas.',
    purpose: 'Ajuda a decidir quando vale perguntar e explica por que o envio pode ficar bloqueado por um tempo.',
    howGenerated: 'A estimativa usa uma pergunta de referência (cerca de 18.700 tokens de entrada, 10.100 deles em cache, e 780 de saída) com o preço atual do servidor. Os limites vêm da configuração do servidor.',
    seeAlso: ['assistant.todayUsage'],
  },
  {
    key: 'assistant.todayUsage',
    label: 'Uso de hoje',
    whatIs: 'Suas perguntas hoje e nos últimos 10 minutos, comparadas aos limites por pessoa, e o custo somado de todas as pessoas hoje contra o teto diário.',
    purpose: 'Mostra quanto falta para o limite antes de enviar, para a pergunta não ser recusada.',
    howGenerated: 'Contado pelo servidor nas perguntas gravadas; o dia vai da meia-noite à meia-noite de Brasília e os 10 minutos são móveis. A tela soma cada resposta recebida e confere de novo com o servidor em seguida.',
  },
  {
    key: 'assistant.trace',
    label: 'Como cheguei nisso',
    whatIs: 'Consultas ao PI que o assistente fez para responder, na ordem: o que consultou, com quais filtros, o status, quantas linhas voltaram, o tempo e a data dos dados.',
    purpose: 'Permite conferir o recorte de cada número e repetir a consulta na tela equivalente do PI.',
    howGenerated: 'Montada pelo servidor com as ferramentas executadas na pergunta. Os filtros aparecem em português; "dados parciais" indica um dia que ainda não fechou.',
    seeAlso: ['assistant.tool.status'],
  },
  {
    key: 'assistant.unverifiedNumbers',
    label: 'Números não conferidos',
    whatIs: 'Números da resposta que o assistente não achou nos resultados das consultas desta pergunta nem nas respostas anteriores da conversa.',
    purpose: 'Alerta para conferir na tela do PI antes de usar o número: pode ser conta feita pelo modelo ou número inventado.',
    howGenerated: 'O servidor compara cada número da resposta com os números devolvidos pelas consultas. Datas, janelas (como 30 dias), anos e posições de lista não entram na conferência.',
  },
  {
    key: 'assistant.usage.period',
    label: 'Período do consumo',
    whatIs: 'Dias em que as perguntas foram feitas: 7, 30 ou 90 dias até hoje, ou um intervalo escolhido. Hoje entra no período.',
    purpose: 'Define o recorte de todos os números desta tela: cartões, tabelas por dia, pessoa e agente e a lista de perguntas.',
    howGenerated: 'Do início do primeiro dia ao fim do último, no horário de Brasília, pela hora em que a pergunta foi enviada. O intervalo vai até 400 dias e não aceita datas futuras.',
  },
  {
    key: 'assistant.usage.personFilter',
    label: 'Pessoa',
    whatIs: 'Mostra só as perguntas de um usuário do Master.',
    purpose: 'Acompanha o uso e o custo de uma pessoa ou investiga uma pergunta específica.',
    howGenerated: 'A lista é montada com as pessoas que apareceram nos períodos já carregados nesta tela, pelo identificador do usuário no Master gravado com a pergunta.',
  },
  {
    key: 'assistant.usage.agentFilter',
    label: 'Agente usado',
    whatIs: 'Mostra só as perguntas respondidas por um agente, depois do roteamento. Automático não aparece porque nunca responde: ele só escolhe.',
    purpose: 'Compara custo, tempo e utilidade de cada especialista.',
    howGenerated: 'Filtra pelo agente que de fato respondeu, gravado com a pergunta. Receita e oportunidades só aparece para quem tem o acesso de Receita.',
  },
  {
    key: 'assistant.usage.statusFilter',
    label: 'Status',
    whatIs: 'Mostra só as perguntas com um status de resposta, como Erro ou Sem dado no PI.',
    purpose: 'Ajuda a revisar erros e recusas para melhorar o assistente.',
    howGenerated: 'Filtra pelo status gravado ao fim de cada pergunta.',
    seeAlso: ['assistant.answerStatus'],
  },
  {
    key: 'assistant.usage.search',
    label: 'Buscar na pergunta',
    whatIs: 'Mostra só as perguntas que contêm o trecho digitado.',
    purpose: 'Acha perguntas sobre um assunto, como uma funcionalidade ou uma empresa.',
    howGenerated: 'Procura o trecho no texto gravado da pergunta, com CPF, e-mail e telefone já mascarados. Sem o acesso de Receita, perguntas de Receita não entram na busca.',
  },
  {
    key: 'assistant.usage.questions',
    label: 'Perguntas',
    whatIs: 'Perguntas enviadas ao assistente no recorte da linha: no período inteiro, no dia, pela pessoa ou respondidas pelo agente. No cartão, abaixo, vem o número de conversas distintas.',
    purpose: 'Mede o uso do assistente e é a base do custo médio, do tempo médio e da taxa de erro.',
    howGenerated: 'Conta as perguntas gravadas no PI dentro do período e dos filtros, inclusive as que deram erro ou ficaram fora do escopo. Pedidos barrados pelo limite de uso ou por falta de acesso não são gravados.',
  },
  {
    key: 'assistant.usage.users',
    label: 'Pessoas',
    whatIs: 'Usuários do Master distintos que fizeram pelo menos uma pergunta no recorte (período inteiro ou o dia da linha).',
    purpose: 'Mostra quantas pessoas usam o assistente, para separar uso espalhado de uso concentrado em poucos.',
    howGenerated: 'Conta os identificadores distintos de usuário do Master gravados com as perguntas do recorte.',
  },
  {
    key: 'assistant.usage.cost',
    label: 'Custo',
    whatIs: 'Custo em dólar (US$) do modelo de linguagem: total do recorte, por dia, por pessoa, por agente, por pergunta ou por chamada, conforme a linha. Na tela, o valor em reais aparece abaixo.',
    purpose: 'Acompanha o gasto com a IA e acha perguntas ou agentes caros.',
    howGenerated: 'Soma de cada chamada ao modelo: tokens de entrada sem cache, em cache e de saída, cada um vezes o preço por milhão da tabela do servidor (gpt-4.1-mini). Valor com 6 casas decimais.',
    caveat: 'No Excel a coluna mostra 1 casa decimal; aumente as casas decimais para ver os centavos.',
    seeAlso: ['assistant.usage.costBrl'],
  },
  {
    key: 'assistant.usage.costBrl',
    label: 'Custo (R$)',
    whatIs: 'O mesmo custo convertido para reais.',
    purpose: 'Facilita comparar o gasto com outros custos da empresa.',
    howGenerated: 'Custo em dólar vezes o câmbio configurado no servidor no momento de cada pergunta; o câmbio usado fica gravado com a pergunta.',
    caveat: 'É uma estimativa: a fatura da Azure é em dólar e o câmbio do dia do pagamento pode ser outro.',
  },
  {
    key: 'assistant.usage.avgCost',
    label: 'Custo médio',
    whatIs: 'Custo médio por pergunta no recorte, em dólar.',
    purpose: 'Compara o custo de agentes e pessoas sem a influência de quantas perguntas cada um fez.',
    howGenerated: 'Custo total do recorte dividido pelo número de perguntas, com 6 casas decimais.',
  },
  {
    key: 'assistant.usage.inputTokens',
    label: 'Tokens de entrada',
    whatIs: 'Pedaços de texto enviados ao modelo: instruções, conhecimento do PI, histórico da conversa, pergunta e resultados das consultas. Os em cache estão incluídos.',
    purpose: 'São a maior parte do custo; muitos tokens de entrada indicam consultas grandes ou conversa longa.',
    howGenerated: 'Informado pela Azure em cada chamada ao modelo e somado no recorte (pergunta, dia, pessoa ou total).',
    seeAlso: ['assistant.usage.cachedTokens'],
  },
  {
    key: 'assistant.usage.cachedTokens',
    label: 'Em cache',
    whatIs: 'Parte dos tokens de entrada que a Azure reaproveitou de chamadas recentes com o mesmo começo de texto.',
    purpose: 'Tokens em cache custam um quarto do preço da entrada; quanto mais cache, mais barata a pergunta.',
    howGenerated: 'Informado pela Azure em cada chamada ao modelo e somado no recorte. Já está incluído nos tokens de entrada.',
  },
  {
    key: 'assistant.usage.outputTokens',
    label: 'Tokens de saída',
    whatIs: 'Pedaços de texto escritos pelo modelo: a resposta e os pedidos de consulta ao PI.',
    purpose: 'Custam 4 vezes o preço da entrada; respostas longas ou muitas consultas aumentam o custo.',
    howGenerated: 'Informado pela Azure em cada chamada ao modelo e somado no recorte.',
  },
  {
    key: 'assistant.usage.totalTokens',
    label: 'Tokens',
    whatIs: 'Total de tokens da pergunta: entrada mais saída. Os em cache já estão na entrada.',
    purpose: 'Ordena as perguntas pelo tamanho do trabalho do modelo.',
    howGenerated: 'Soma dos tokens de entrada e de saída de todas as chamadas ao modelo da pergunta, inclusive a do roteador. O detalhe aparece ao passar o mouse.',
  },
  {
    key: 'assistant.usage.avgLatency',
    label: 'Tempo médio',
    whatIs: 'Tempo médio entre enviar a pergunta e receber a resposta. No cartão, abaixo, vem o p95: 95% das perguntas terminaram em até esse tempo.',
    purpose: 'Acompanha a espera de quem pergunta e mostra agentes lentos.',
    howGenerated: 'Média do tempo total de cada pergunta do recorte, medido pelo servidor do envio ao fim da resposta. Na planilha sai em segundos.',
  },
  {
    key: 'assistant.usage.latency',
    label: 'Tempo',
    whatIs: 'Tempo entre enviar a pergunta e receber a resposta.',
    purpose: 'Acha perguntas lentas para investigar no detalhe (modelo ou consultas).',
    howGenerated: 'Medido pelo servidor do envio ao fim da resposta; soma roteador, chamadas ao modelo e consultas ao PI. Na planilha sai em segundos.',
  },
  {
    key: 'assistant.usage.errorRate',
    label: 'Com erro',
    whatIs: 'Parte das perguntas do período que terminou com status Erro.',
    purpose: 'Mede a estabilidade do assistente; recusas e "sem dado" não contam como erro.',
    howGenerated: 'Perguntas com status Erro divididas pelo total de perguntas do recorte, vezes 100, com 1 casa decimal.',
    seeAlso: ['assistant.answerStatus'],
  },
  {
    key: 'assistant.usage.usefulRate',
    label: 'Útil',
    whatIs: 'Parte das perguntas avaliadas que recebeu "Útil". No cartão, abaixo, vem quantas foram avaliadas.',
    purpose: 'Mede a qualidade percebida das respostas, por agente e no total.',
    howGenerated: 'Avaliações "Útil" divididas pelas perguntas avaliadas (Útil ou Não útil), vezes 100. Perguntas sem avaliação ficam de fora.',
    caveat: 'Com poucas avaliações a taxa muda muito com um voto.',
  },
  {
    key: 'assistant.usage.day',
    label: 'Dia',
    whatIs: 'Dia em que as perguntas foram enviadas.',
    purpose: 'Mostra a evolução do uso e do custo ao longo do período.',
    howGenerated: 'Data de Brasília (UTC−3) do envio de cada pergunta. Dias sem perguntas não aparecem.',
  },
  {
    key: 'assistant.usage.person',
    label: 'Pessoa',
    whatIs: 'Usuário do Master que fez as perguntas, com o e-mail abaixo.',
    purpose: 'Mostra quem mais usa e quem mais gasta; "Só esta" filtra a tela por essa pessoa.',
    howGenerated: 'Nome e e-mail gravados com a pergunta mais recente da pessoa no recorte. A lista vem ordenada pelo custo, do maior para o menor.',
  },
  {
    key: 'assistant.usage.email',
    label: 'E-mail',
    whatIs: 'E-mail do usuário do Master que enviou a pergunta.',
    purpose: 'Identifica a pessoa sem ambiguidade quando dois nomes são parecidos.',
    howGenerated: 'Gravado com a pergunta a partir do cadastro do usuário no Master no momento do envio.',
  },
  {
    key: 'assistant.usage.userId',
    label: 'Identificador no Master',
    whatIs: 'Código do usuário do Master que fez as perguntas.',
    purpose: 'Cruza a planilha com outras bases do Master sem depender do nome.',
    howGenerated: 'Gravado com cada pergunta a partir do login no Master.',
  },
  {
    key: 'assistant.usage.lastAsked',
    label: 'Última',
    whatIs: 'Data e hora da pergunta mais recente da pessoa no recorte.',
    purpose: 'Mostra quem usa o assistente com frequência e quem parou.',
    howGenerated: 'Maior horário de envio entre as perguntas da pessoa no recorte, mostrado no horário de Brasília.',
  },
  {
    key: 'assistant.usage.agentUsed',
    label: 'Agente usado',
    whatIs: 'Especialista que de fato respondeu a pergunta, depois do roteamento.',
    purpose: 'Compara volume, custo, tempo e utilidade de cada especialista.',
    howGenerated: 'Gravado ao fim de cada pergunta: o escolhido por você ou, no Automático, o que o roteador escolheu. Na tabela por agente, a ordem é pelo número de perguntas.',
    seeAlso: ['assistant.agent'],
  },
  {
    key: 'assistant.usage.agentRequested',
    label: 'Agente escolhido',
    whatIs: 'Agente escolhido por quem perguntou no seletor da tela, como Automático ou um especialista.',
    purpose: 'Comparado ao agente usado, mostra quando o roteador mudou o especialista.',
    howGenerated: 'Gravado no envio da pergunta.',
  },
  {
    key: 'assistant.usage.agentPath',
    label: 'Agente',
    whatIs: 'Agente que respondeu. Quando ele é diferente do escolhido, aparece "escolhido → usado", como "Automático → Funcionalidades e adoção".',
    purpose: 'Mostra a escolha do roteador em cada pergunta.',
    howGenerated: 'Agente escolhido gravado no envio e agente usado gravado ao fim da pergunta. Na planilha, cada um vai numa coluna.',
    seeAlso: ['assistant.usage.agentRequested', 'assistant.usage.agentUsed'],
  },
  {
    key: 'assistant.usage.askedAt',
    label: 'Data e hora',
    whatIs: 'Momento em que a pergunta foi enviada.',
    purpose: 'Ordena as perguntas e localiza uma pergunta citada por alguém.',
    howGenerated: 'Hora do servidor no envio, mostrada no horário de Brasília.',
  },
  {
    key: 'assistant.usage.sender',
    label: 'Quem enviou',
    whatIs: 'Usuário do Master que fez a pergunta, com o e-mail abaixo.',
    purpose: 'Permite revisar as perguntas de cada pessoa e responder dúvidas sobre uma resposta.',
    howGenerated: 'Nome e e-mail do usuário do Master gravados com a pergunta no momento do envio.',
  },
  {
    key: 'assistant.usage.question',
    label: 'Pergunta',
    whatIs: 'Texto da pergunta enviada ao assistente. Na tela aparece cortado; clique para ver a pergunta inteira, a resposta, as chamadas e o custo.',
    purpose: 'Mostra o que as pessoas querem saber e serve para revisar respostas ruins.',
    howGenerated: 'Gravado como foi enviado ao modelo, com CPF, e-mail e telefone mascarados. Sem o acesso de Receita, perguntas de Receita aparecem com o texto oculto.',
  },
  {
    key: 'assistant.usage.feedback',
    label: 'Avaliação',
    whatIs: 'Avaliação dada por quem perguntou: Útil ou Não útil, com comentário opcional.',
    purpose: 'Aponta as respostas a revisar e alimenta a taxa de respostas úteis.',
    howGenerated: 'Gravada quando a pessoa clica em Útil ou Não útil na resposta; a última escolha vale.',
  },
  {
    key: 'assistant.usage.modelCalls',
    label: 'Chamadas ao modelo',
    whatIs: 'Quantas vezes o modelo de linguagem foi chamado para responder a pergunta, contando o roteador.',
    purpose: 'Muitas chamadas indicam que o modelo precisou de várias consultas até responder.',
    howGenerated: 'Contadas pelo servidor durante a pergunta, até o limite de 6 por pergunta.',
  },
  {
    key: 'assistant.usage.toolCalls',
    label: 'Consultas ao PI',
    whatIs: 'Quantas consultas aos números do PI o modelo fez para responder.',
    purpose: 'Mostra se a resposta se apoiou em dados; resposta sem consulta merece conferência.',
    howGenerated: 'Contadas pelo servidor durante a pergunta, até o limite de 10 por pergunta.',
  },
  {
    key: 'assistant.usage.interactionId',
    label: 'Número da pergunta',
    whatIs: 'Número único da pergunta no registro do assistente, o mesmo do título "Pergunta #" no detalhe.',
    purpose: 'Localiza a pergunta no Consumo da IA para ver a entrada, a saída e o custo.',
    howGenerated: 'Gerado pelo banco do PI quando a pergunta é gravada.',
  },
  {
    key: 'assistant.call.index',
    label: 'Número da chamada',
    whatIs: 'Ordem da chamada ao modelo dentro da pergunta, começando em 0.',
    purpose: 'Liga a chamada às consultas que ela pediu (coluna Chamada das consultas ao PI).',
    howGenerated: 'Numerada pelo servidor na ordem em que as chamadas foram feitas.',
  },
  {
    key: 'assistant.call.purpose',
    label: 'Finalidade',
    whatIs: 'Para que a chamada serviu: Roteador (escolher o especialista) ou Resposta (pedir consultas ou escrever a resposta).',
    purpose: 'Separa o custo de escolher o agente do custo de responder.',
    howGenerated: 'Marcada pelo servidor em cada chamada. Abaixo aparecem o modelo (quando é outro), o prompt usado e o código de erro, se houver.',
  },
  {
    key: 'assistant.call.model',
    label: 'Modelo',
    whatIs: 'Versão do modelo de linguagem que a Azure informou nesta chamada.',
    purpose: 'Mostra se a Azure trocou a versão, o que muda custo e comportamento.',
    howGenerated: 'Lido da resposta da Azure em cada chamada.',
  },
  {
    key: 'assistant.call.prompt',
    label: 'Prompt',
    whatIs: 'Código curto (hash) das instruções de sistema usadas na chamada.',
    purpose: 'Liga a resposta à versão exata das instruções, para comparar mudanças de prompt.',
    howGenerated: 'Calculado pelo servidor sobre o texto das instruções; o texto fica guardado no banco do PI.',
  },
  {
    key: 'assistant.call.error',
    label: 'Erro da chamada',
    whatIs: 'Código do erro devolvido pela Azure ou pelo servidor nesta chamada, quando houve.',
    purpose: 'Ajuda a investigar perguntas com status Erro.',
    howGenerated: 'Gravado pelo servidor quando a chamada falha ou estoura o tempo.',
  },
  {
    key: 'assistant.call.startedAt',
    label: 'Início',
    whatIs: 'Momento em que a chamada ao modelo começou.',
    purpose: 'Mostra a sequência e os intervalos entre as chamadas da pergunta.',
    howGenerated: 'Hora do servidor no envio da chamada à Azure, mostrada no horário de Brasília.',
  },
  {
    key: 'assistant.call.messages',
    label: 'Mensagens',
    whatIs: 'Quantas mensagens foram enviadas ao modelo nesta chamada: instruções, contexto, histórico, pergunta, pedidos e resultados de consultas.',
    purpose: 'Explica o crescimento dos tokens de entrada a cada nova chamada.',
    howGenerated: 'Contadas pelo servidor ao montar a chamada; a transcrição marca quais mensagens entraram em cada chamada.',
  },
  {
    key: 'assistant.call.finish',
    label: 'Fim',
    whatIs: 'Como a chamada terminou: terminou (escreveu a resposta), pediu ferramentas, cortada pelo limite de tokens ou bloqueada pelo filtro de conteúdo.',
    purpose: 'Mostra se a resposta foi cortada ou bloqueada.',
    howGenerated: 'Motivo de fim informado pela Azure em cada chamada, entre parênteses o código original.',
  },
  {
    key: 'assistant.call.tools',
    label: 'Ferramentas',
    whatIs: 'Quantas consultas ao PI o modelo pediu nesta chamada.',
    purpose: 'Mostra em que chamada as consultas foram pedidas.',
    howGenerated: 'Contadas na resposta da Azure; o servidor executa até 4 por chamada e 10 por pergunta.',
  },
  {
    key: 'assistant.call.latency',
    label: 'Tempo da chamada',
    whatIs: 'Tempo que a Azure levou para responder esta chamada.',
    purpose: 'Separa a demora do modelo da demora das consultas ao PI.',
    howGenerated: 'Medido pelo servidor do envio à resposta da chamada, com limite de 45 s. Na planilha sai em segundos.',
  },
  {
    key: 'assistant.tool.call',
    label: 'Chamada',
    whatIs: 'Chamada ao modelo que pediu a consulta e a ordem da consulta dentro dela, como #2.0.',
    purpose: 'Liga cada consulta à chamada ao modelo da tabela acima.',
    howGenerated: 'Número da chamada ao modelo, ponto, ordem da consulta pedida nela. Abaixo aparece o identificador que a Azure deu ao pedido.',
  },
  {
    key: 'assistant.tool.callId',
    label: 'Identificador da chamada',
    whatIs: 'Código que a Azure deu ao pedido de consulta.',
    purpose: 'Liga a consulta à mensagem correspondente na transcrição.',
    howGenerated: 'Lido do pedido de ferramenta na resposta da Azure.',
  },
  {
    key: 'assistant.tool.name',
    label: 'Ferramenta',
    whatIs: 'Consulta do PI pedida pelo modelo, como get_feature_detail (ficha da funcionalidade). Abaixo aparecem a rota do PI e a data dos dados.',
    purpose: 'Mostra de onde veio cada número da resposta e permite repetir a consulta na tela equivalente.',
    howGenerated: 'Cada ferramenta lê uma rota do PI com os mesmos filtros e regras das telas; nenhuma lê os bancos dos clientes na hora.',
  },
  {
    key: 'assistant.tool.endpoint',
    label: 'Rota do PI',
    whatIs: 'Rota da API do PI que a ferramenta leu, como features/{featureType}.',
    purpose: 'Liga a consulta à tela do PI que mostra os mesmos números.',
    howGenerated: 'Gravada pelo servidor ao executar a ferramenta. Ferramentas que só leem o conhecimento do assistente não têm rota.',
  },
  {
    key: 'assistant.tool.arguments',
    label: 'Argumentos',
    whatIs: 'Filtros que o modelo passou para a consulta, como funcionalidade, período e papel do usuário.',
    purpose: 'Mostra exatamente o recorte usado, para conferir se é o que a pergunta pediu.',
    howGenerated: 'Texto pedido pelo modelo, conferido pelo servidor antes da consulta; argumento inválido devolve erro ao modelo sem consultar.',
  },
  {
    key: 'assistant.tool.status',
    label: 'Status da consulta',
    whatIs: 'Resultado da consulta: ok, sem linhas, argumento inválido, negada, não encontrado, tempo esgotado, erro ou pulada.',
    purpose: 'Mostra se a resposta se baseou em dados ou se alguma consulta falhou.',
    howGenerated: 'Definido pelo servidor ao executar a ferramenta. Negada é falta de acesso, como o de Receita; pulada é consulta pedida depois do limite de consultas ou de tempo da pergunta.',
  },
  {
    key: 'assistant.tool.error',
    label: 'Erro da consulta',
    whatIs: 'Mensagem de erro da consulta, quando ela falhou.',
    purpose: 'Ajuda a investigar respostas sem dado ou com erro.',
    howGenerated: 'Gravada pelo servidor quando a ferramenta falha, é negada ou estoura o tempo.',
  },
  {
    key: 'assistant.tool.rows',
    label: 'Linhas',
    whatIs: 'Quantas linhas de dados a consulta devolveu.',
    purpose: 'Consulta com zero linhas explica respostas sem dado.',
    howGenerated: 'Contadas pelo servidor no resultado da ferramenta, antes de enviar ao modelo.',
  },
  {
    key: 'assistant.tool.chars',
    label: 'Caracteres',
    whatIs: 'Tamanho do resultado da consulta enviado ao modelo, em caracteres.',
    purpose: 'Resultados grandes encarecem as chamadas seguintes.',
    howGenerated: 'Medido pelo servidor no texto enviado ao modelo, depois de reduzido para até 12.000 caracteres.',
  },
  {
    key: 'assistant.tool.tokens',
    label: 'Tokens (estimativa)',
    whatIs: 'Estimativa de quantos tokens de entrada o resultado da consulta ocupou.',
    purpose: 'Mostra o peso de cada consulta no custo da pergunta.',
    howGenerated: 'Caracteres do resultado divididos por 4. A contagem real vem somada nos tokens de entrada da chamada seguinte.',
  },
  {
    key: 'assistant.tool.truncated',
    label: 'Cortado',
    whatIs: 'Indica se o resultado da consulta foi reduzido antes de ir ao modelo.',
    purpose: 'Resultado cortado pode deixar linhas de fora da resposta; confira na tela do PI.',
    howGenerated: 'Quando o resultado passa de 12.000 caracteres, o servidor tira as últimas linhas da maior lista até caber e, se ainda não couber, encurta os textos.',
  },
  {
    key: 'assistant.tool.latency',
    label: 'Tempo da consulta',
    whatIs: 'Tempo que a consulta ao PI levou.',
    purpose: 'Separa a demora das consultas da demora do modelo.',
    howGenerated: 'Medido pelo servidor do início ao fim da ferramenta, com limite de 20 s. Na planilha sai em segundos.',
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/assistant.js